/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type AssetState =
  | "ASSET_STATE_DEFECT"
  | "ASSET_STATE_IN_REPAIR"
  | "ASSET_STATE_IN_TRANSIT"
  | "ASSET_STATE_LOST"
  | "ASSET_STATE_OPERATIONAL"
  | "ASSET_STATE_OUTBOUNDED"
  | "ASSET_STATE_PARTIALLY_OPERATIONAL"
  | "ASSET_STATE_STOLEN"
  | "ASSET_STATE_UNSPECIFIED";

export type AssetTypes = "BIKE_BATTERY";

export type CreateAssetInput = {
  modelId: string;
  serialNumber: string;
  supplierId: string;
};

export type DamageReportInput = {
  assetId: string;
  description?: string | null | undefined;
  type: DamageType;
};

export type DamageType =
  | "DAMAGE_TYPE_HANDLE_BROKEN"
  | "DAMAGE_TYPE_IDENTIFIER_MISSING"
  | "DAMAGE_TYPE_KEY_STUCK"
  | "DAMAGE_TYPE_LOW_BATTERY_CAPACITY"
  | "DAMAGE_TYPE_NOT_CHARGING"
  | "DAMAGE_TYPE_PHYSICAL_DAMAGE";

export type GetAssetByIdInput = {
  assetId: string;
};

export type GetAssetsByHubInput = {
  assetType?: AssetTypes | null | undefined;
  limit?: number | null | undefined;
  page?: number | null | undefined;
  state?: Array<AssetState> | null | undefined;
};

export type ReportStatus = "REPORT_STATUS_OPEN";

export type SearchAssetsInput = {
  assetType?: AssetTypes | null | undefined;
  hubCode?: string | null | undefined;
  limit?: number | null | undefined;
  modelId?: string | null | undefined;
  page?: number | null | undefined;
  serialNumber?: string | null | undefined;
  state?: AssetState | null | undefined;
  supplierId?: string | null | undefined;
};

export type TransferAssetInput = {
  assetId: string;
  fromHubCode: string;
};

export type UpdateAssetStateInput = {
  assetId: string;
  newState: AssetState;
};

export type GetAssetByIdQueryVariables = Exact<{
  input: Types.GetAssetByIdInput;
}>;

export type GetAssetByIdQuery = {
  getAssetById: {
    asset: {
      id: string;
      serialNumber: string;
      state: Types.AssetState;
      hubCode: string;
      createdAt: string;
      updatedAt: string;
      supplier: { id: string | null; name: string | null } | null;
      model: { id: string | null; name: string | null } | null;
    } | null;
  };
};

export type GetAssetsByHubQueryVariables = Exact<{
  input?: Types.GetAssetsByHubInput | null | undefined;
}>;

export type GetAssetsByHubQuery = {
  getAssetsByHub: {
    assets: Array<{
      id: string;
      serialNumber: string;
      state: Types.AssetState;
      hubCode: string;
      createdAt: string;
      updatedAt: string;
      supplier: { id: string | null; name: string | null } | null;
      model: { id: string | null; name: string | null } | null;
    }>;
    pagination: { total: number; page: number; limit: number; totalPages: number };
  };
};

export type SearchAssetsQueryVariables = Exact<{
  input?: Types.SearchAssetsInput | null | undefined;
}>;

export type SearchAssetsQuery = {
  searchAssets: {
    assets: Array<{
      id: string;
      serialNumber: string;
      state: Types.AssetState;
      hubCode: string;
      createdAt: string;
      updatedAt: string;
      supplier: { id: string | null; name: string | null } | null;
      model: { id: string | null; name: string | null } | null;
    }>;
    pagination: { total: number; page: number; limit: number; totalPages: number };
  };
};

export type GetModelsQueryVariables = Exact<{ [key: string]: never }>;

export type GetModelsQuery = {
  getModels: {
    models: Array<{ modelId: string; name: string; supplier: { id: string; name: string } }>;
  };
};

export type CreateAssetMutationVariables = Exact<{
  input: Types.CreateAssetInput;
}>;

export type CreateAssetMutation = {
  createAsset: {
    asset: {
      id: string;
      serialNumber: string;
      state: Types.AssetState;
      hubCode: string;
      createdAt: string;
      updatedAt: string;
      supplier: { id: string | null; name: string | null } | null;
      model: { id: string | null; name: string | null } | null;
    };
  };
};

export type TransferAssetMutationVariables = Exact<{
  input: Types.TransferAssetInput;
}>;

export type TransferAssetMutation = {
  transferAsset: {
    asset: {
      id: string;
      serialNumber: string;
      state: Types.AssetState;
      hubCode: string;
      createdAt: string;
      updatedAt: string;
      supplier: { id: string | null; name: string | null } | null;
      model: { id: string | null; name: string | null } | null;
    };
  };
};

export type UpdateAssetStateMutationVariables = Exact<{
  input: Types.UpdateAssetStateInput;
}>;

export type UpdateAssetStateMutation = {
  updateAssetState: {
    asset: {
      id: string;
      serialNumber: string;
      state: Types.AssetState;
      hubCode: string;
      createdAt: string;
      updatedAt: string;
      supplier: { id: string | null; name: string | null } | null;
      model: { id: string | null; name: string | null } | null;
    };
  };
};

export type DamageReportMutationVariables = Exact<{
  input: Types.DamageReportInput;
}>;

export type DamageReportMutation = {
  damageReport: {
    asset: { assetId: string; state: Types.AssetState };
    damageReport: {
      id: string;
      type: Types.DamageType;
      status: Types.ReportStatus;
      description: string | null;
    };
  };
};

export const GetAssetByIdDocument = gql`
  query GetAssetById($input: GetAssetByIdInput!) {
    getAssetById(input: $input) {
      asset {
        id
        serialNumber
        supplier {
          id
          name
        }
        model {
          id
          name
        }
        state
        hubCode
        createdAt
        updatedAt
      }
    }
  }
`;

/**
 * __useGetAssetByIdQuery__
 *
 * To run a query within a React component, call `useGetAssetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAssetByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetAssetByIdQuery, GetAssetByIdQueryVariables> &
    ({ variables: GetAssetByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAssetByIdQuery, GetAssetByIdQueryVariables>(
    GetAssetByIdDocument,
    options,
  );
}
export function useGetAssetByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAssetByIdQuery, GetAssetByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAssetByIdQuery, GetAssetByIdQueryVariables>(
    GetAssetByIdDocument,
    options,
  );
}
// @ts-ignore
export function useGetAssetByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssetByIdQuery, GetAssetByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetAssetByIdQuery, GetAssetByIdQueryVariables>;
export function useGetAssetByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAssetByIdQuery, GetAssetByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetAssetByIdQuery | undefined, GetAssetByIdQueryVariables>;
export function useGetAssetByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAssetByIdQuery, GetAssetByIdQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAssetByIdQuery, GetAssetByIdQueryVariables>(
    GetAssetByIdDocument,
    options,
  );
}
export type GetAssetByIdQueryHookResult = ReturnType<typeof useGetAssetByIdQuery>;
export type GetAssetByIdLazyQueryHookResult = ReturnType<typeof useGetAssetByIdLazyQuery>;
export type GetAssetByIdSuspenseQueryHookResult = ReturnType<typeof useGetAssetByIdSuspenseQuery>;
export type GetAssetByIdQueryResult = Apollo.QueryResult<
  GetAssetByIdQuery,
  GetAssetByIdQueryVariables
>;
export const GetAssetsByHubDocument = gql`
  query GetAssetsByHub($input: GetAssetsByHubInput) {
    getAssetsByHub(input: $input) {
      assets {
        id
        serialNumber
        supplier {
          id
          name
        }
        model {
          id
          name
        }
        state
        hubCode
        createdAt
        updatedAt
      }
      pagination {
        total
        page
        limit
        totalPages
      }
    }
  }
`;

/**
 * __useGetAssetsByHubQuery__
 *
 * To run a query within a React component, call `useGetAssetsByHubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetsByHubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetsByHubQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAssetsByHubQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAssetsByHubQuery, GetAssetsByHubQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAssetsByHubQuery, GetAssetsByHubQueryVariables>(
    GetAssetsByHubDocument,
    options,
  );
}
export function useGetAssetsByHubLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAssetsByHubQuery, GetAssetsByHubQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAssetsByHubQuery, GetAssetsByHubQueryVariables>(
    GetAssetsByHubDocument,
    options,
  );
}
// @ts-ignore
export function useGetAssetsByHubSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssetsByHubQuery, GetAssetsByHubQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetAssetsByHubQuery, GetAssetsByHubQueryVariables>;
export function useGetAssetsByHubSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAssetsByHubQuery, GetAssetsByHubQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetAssetsByHubQuery | undefined, GetAssetsByHubQueryVariables>;
export function useGetAssetsByHubSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAssetsByHubQuery, GetAssetsByHubQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAssetsByHubQuery, GetAssetsByHubQueryVariables>(
    GetAssetsByHubDocument,
    options,
  );
}
export type GetAssetsByHubQueryHookResult = ReturnType<typeof useGetAssetsByHubQuery>;
export type GetAssetsByHubLazyQueryHookResult = ReturnType<typeof useGetAssetsByHubLazyQuery>;
export type GetAssetsByHubSuspenseQueryHookResult = ReturnType<
  typeof useGetAssetsByHubSuspenseQuery
>;
export type GetAssetsByHubQueryResult = Apollo.QueryResult<
  GetAssetsByHubQuery,
  GetAssetsByHubQueryVariables
>;
export const SearchAssetsDocument = gql`
  query SearchAssets($input: SearchAssetsInput) {
    searchAssets(input: $input) {
      assets {
        id
        serialNumber
        supplier {
          id
          name
        }
        model {
          id
          name
        }
        state
        hubCode
        createdAt
        updatedAt
      }
      pagination {
        total
        page
        limit
        totalPages
      }
    }
  }
`;

/**
 * __useSearchAssetsQuery__
 *
 * To run a query within a React component, call `useSearchAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAssetsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchAssetsQuery(
  baseOptions?: Apollo.QueryHookOptions<SearchAssetsQuery, SearchAssetsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchAssetsQuery, SearchAssetsQueryVariables>(
    SearchAssetsDocument,
    options,
  );
}
export function useSearchAssetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchAssetsQuery, SearchAssetsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchAssetsQuery, SearchAssetsQueryVariables>(
    SearchAssetsDocument,
    options,
  );
}
// @ts-ignore
export function useSearchAssetsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<SearchAssetsQuery, SearchAssetsQueryVariables>,
): Apollo.UseSuspenseQueryResult<SearchAssetsQuery, SearchAssetsQueryVariables>;
export function useSearchAssetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchAssetsQuery, SearchAssetsQueryVariables>,
): Apollo.UseSuspenseQueryResult<SearchAssetsQuery | undefined, SearchAssetsQueryVariables>;
export function useSearchAssetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchAssetsQuery, SearchAssetsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SearchAssetsQuery, SearchAssetsQueryVariables>(
    SearchAssetsDocument,
    options,
  );
}
export type SearchAssetsQueryHookResult = ReturnType<typeof useSearchAssetsQuery>;
export type SearchAssetsLazyQueryHookResult = ReturnType<typeof useSearchAssetsLazyQuery>;
export type SearchAssetsSuspenseQueryHookResult = ReturnType<typeof useSearchAssetsSuspenseQuery>;
export type SearchAssetsQueryResult = Apollo.QueryResult<
  SearchAssetsQuery,
  SearchAssetsQueryVariables
>;
export const GetModelsDocument = gql`
  query GetModels {
    getModels {
      models {
        modelId
        name
        supplier {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useGetModelsQuery__
 *
 * To run a query within a React component, call `useGetModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetModelsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetModelsQuery, GetModelsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetModelsQuery, GetModelsQueryVariables>(GetModelsDocument, options);
}
export function useGetModelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetModelsQuery, GetModelsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetModelsQuery, GetModelsQueryVariables>(GetModelsDocument, options);
}
// @ts-ignore
export function useGetModelsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetModelsQuery, GetModelsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetModelsQuery, GetModelsQueryVariables>;
export function useGetModelsSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModelsQuery, GetModelsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetModelsQuery | undefined, GetModelsQueryVariables>;
export function useGetModelsSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModelsQuery, GetModelsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetModelsQuery, GetModelsQueryVariables>(
    GetModelsDocument,
    options,
  );
}
export type GetModelsQueryHookResult = ReturnType<typeof useGetModelsQuery>;
export type GetModelsLazyQueryHookResult = ReturnType<typeof useGetModelsLazyQuery>;
export type GetModelsSuspenseQueryHookResult = ReturnType<typeof useGetModelsSuspenseQuery>;
export type GetModelsQueryResult = Apollo.QueryResult<GetModelsQuery, GetModelsQueryVariables>;
export const CreateAssetDocument = gql`
  mutation CreateAsset($input: CreateAssetInput!) {
    createAsset(input: $input) {
      asset {
        id
        serialNumber
        supplier {
          id
          name
        }
        model {
          id
          name
        }
        state
        hubCode
        createdAt
        updatedAt
      }
    }
  }
`;
export type CreateAssetMutationFn = Apollo.MutationFunction<
  CreateAssetMutation,
  CreateAssetMutationVariables
>;

/**
 * __useCreateAssetMutation__
 *
 * To run a mutation, you first call `useCreateAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetMutation, { data, loading, error }] = useCreateAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssetMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateAssetMutation, CreateAssetMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateAssetMutation, CreateAssetMutationVariables>(
    CreateAssetDocument,
    options,
  );
}
export type CreateAssetMutationHookResult = ReturnType<typeof useCreateAssetMutation>;
export type CreateAssetMutationResult = Apollo.MutationResult<CreateAssetMutation>;
export type CreateAssetMutationOptions = Apollo.BaseMutationOptions<
  CreateAssetMutation,
  CreateAssetMutationVariables
>;
export const TransferAssetDocument = gql`
  mutation TransferAsset($input: TransferAssetInput!) {
    transferAsset(input: $input) {
      asset {
        id
        serialNumber
        supplier {
          id
          name
        }
        model {
          id
          name
        }
        state
        hubCode
        createdAt
        updatedAt
      }
    }
  }
`;
export type TransferAssetMutationFn = Apollo.MutationFunction<
  TransferAssetMutation,
  TransferAssetMutationVariables
>;

/**
 * __useTransferAssetMutation__
 *
 * To run a mutation, you first call `useTransferAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferAssetMutation, { data, loading, error }] = useTransferAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferAssetMutation(
  baseOptions?: Apollo.MutationHookOptions<TransferAssetMutation, TransferAssetMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TransferAssetMutation, TransferAssetMutationVariables>(
    TransferAssetDocument,
    options,
  );
}
export type TransferAssetMutationHookResult = ReturnType<typeof useTransferAssetMutation>;
export type TransferAssetMutationResult = Apollo.MutationResult<TransferAssetMutation>;
export type TransferAssetMutationOptions = Apollo.BaseMutationOptions<
  TransferAssetMutation,
  TransferAssetMutationVariables
>;
export const UpdateAssetStateDocument = gql`
  mutation UpdateAssetState($input: UpdateAssetStateInput!) {
    updateAssetState(input: $input) {
      asset {
        id
        serialNumber
        supplier {
          id
          name
        }
        model {
          id
          name
        }
        state
        hubCode
        createdAt
        updatedAt
      }
    }
  }
`;
export type UpdateAssetStateMutationFn = Apollo.MutationFunction<
  UpdateAssetStateMutation,
  UpdateAssetStateMutationVariables
>;

/**
 * __useUpdateAssetStateMutation__
 *
 * To run a mutation, you first call `useUpdateAssetStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssetStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssetStateMutation, { data, loading, error }] = useUpdateAssetStateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssetStateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAssetStateMutation,
    UpdateAssetStateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateAssetStateMutation, UpdateAssetStateMutationVariables>(
    UpdateAssetStateDocument,
    options,
  );
}
export type UpdateAssetStateMutationHookResult = ReturnType<typeof useUpdateAssetStateMutation>;
export type UpdateAssetStateMutationResult = Apollo.MutationResult<UpdateAssetStateMutation>;
export type UpdateAssetStateMutationOptions = Apollo.BaseMutationOptions<
  UpdateAssetStateMutation,
  UpdateAssetStateMutationVariables
>;
export const DamageReportDocument = gql`
  mutation DamageReport($input: DamageReportInput!) {
    damageReport(input: $input) {
      asset {
        assetId
        state
      }
      damageReport {
        id
        type
        status
        description
      }
    }
  }
`;
export type DamageReportMutationFn = Apollo.MutationFunction<
  DamageReportMutation,
  DamageReportMutationVariables
>;

/**
 * __useDamageReportMutation__
 *
 * To run a mutation, you first call `useDamageReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDamageReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [damageReportMutation, { data, loading, error }] = useDamageReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDamageReportMutation(
  baseOptions?: Apollo.MutationHookOptions<DamageReportMutation, DamageReportMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DamageReportMutation, DamageReportMutationVariables>(
    DamageReportDocument,
    options,
  );
}
export type DamageReportMutationHookResult = ReturnType<typeof useDamageReportMutation>;
export type DamageReportMutationResult = Apollo.MutationResult<DamageReportMutation>;
export type DamageReportMutationOptions = Apollo.BaseMutationOptions<
  DamageReportMutation,
  DamageReportMutationVariables
>;
